

<div class="exprx--common-block erx--body insurance--body">
    <div class="eprx--block__header text-white pl-3 font-weight-bold">
        Pharmacist Notes (For Internal Reference Only)
    </div>
    <div
    class="eprx--block__content pt-0 height_155" >
        <div class="row row-space-transfer-in">
            <div class="col-6">
                <label>{{notesLabels.Category}}: </label> &nbsp; {{requestedNotesInfo ? 'eRx' : msgConfig.EMPTY_Data}}
            </div> 
        </div>
        <div class="row row-space-transfer-in">
            <div class="col-6">
                <label>{{notesLabels.SubCategory}}</label>
                <div >{{requestedNotesInfo?.NoteCatName ? requestedNotesInfo?.NoteCatName : msgConfig.EMPTY_Data}}</div>
            </div>
            <div class="col-3">
                <label>{{notesLabels.Popupcodes}}</label>
                <div >{{requestedNotesInfo?.PopupScreenCodes ? (requestedNotesInfo?.PopupScreenCodes | uppercase) : msgConfig.EMPTY_Data}}</div>
            </div>
        </div>
        <div class="row row-space-transfer-in">
            <div class="col-12">
                <label>{{notesLabels.Notes}}</label>
                <div class="label--data ellpise text_transform"  [ngbTooltip]="(requestedNotesInfo?.xNote)? (requestedNotesInfo?.xNote) :''" triggers="mouseover:mouseleave"
                [autoClose]="true" placement="top-start" ><span>{{requestedNotesInfo?.xNote ?
                        requestedNotesInfo?.xNote : msgConfig.EMPTY_Data}}</span></div>
            </div>
        </div>
    </div>
</div>

